.container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--skeleton-grey);
    gap: 8px;
    overflow: auto;
    position: relative;
    min-width: 1225px;
}

.container--full-height-sidebar {
    flex-direction: row;
    /* Match CoreEntityContentContainer horizontal gap between main column and sidebar */
    gap: 8px;
    overflow: hidden;
    align-items: stretch;
}

.fake-border-radius-container {
    position: absolute;
    top: 0;
    left: 0;
    height: 16px;
    width: 16px;
    /* One less than the global search popover */
    z-index: 99;
}

.fake-border-radius {
    position: relative;
    top: 0;
    left: 0;
    height: 16px;
    width: 16px;
    overflow: hidden;
}

.fake-border-radius:after {
    content: '';
    position: absolute;
    border-radius: 50% 0 0 0;
    height: 16px;
    width: 16px;
    box-shadow: 0 0 0 2000px var(--sidebar-primary);
}

.fake-border-radius--dev {
    &:after {
        box-shadow: 0 0 0 2000px #3e405c;
    }
}
